import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetIpInefficientUseRequest
} from '../requests/IpAuditsRequests.js';

export const GET_IP_INEFFICIENT_USE = 'GET_IP_INEFFICIENT_USE';

export const GetIpInefficientUse = (userId) => async (dispatch) => {
	await GetIpInefficientUseRequest(userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
